export default __webpack_public_path__ + "media/images/images/icons/browser-197d393dbd1183ba5b4c2e9af1a27d31.png";